// Costura.js — a passagem de uma seção para a outra (18/10/2026).
//
// A mesma do site principal (insigne-landing-page, ui/Costura): a fita
// laranja em miniatura, uma fina laranja e uma azul cruzadas, com a marca no
// ponto onde se cruzam e um brilho laranja em volta. Separa duas seções no
// mesmo fundo sem o degrau reto de cor entre elas.
//
// `invertida` espelha as inclinações, para duas costuras seguidas não
// ficarem paralelas.
import React from "react";
import Marca from "./Marca";

export default function Costura({ invertida = false }) {
  return (
    <div className="relative h-16 overflow-hidden sm:h-24" aria-hidden="true">
      <div className="absolute inset-x-0 top-1/2 h-24 -translate-y-1/2 bg-[radial-gradient(ellipse_50%_50%_at_center,rgb(var(--c-orange)/0.16),transparent)]" />
      <div
        className={
          "absolute -inset-x-[6%] top-1/2 h-2.5 -translate-y-1/2 border-y-2 border-insigne-sombra bg-insigne-navy-mid " +
          (invertida ? "-rotate-[1.6deg]" : "rotate-[1.6deg]")
        }
      />
      <div
        className={
          "absolute -inset-x-[6%] top-1/2 h-2 -translate-y-1/2 border-y border-insigne-sombra bg-insigne-orange " +
          (invertida ? "rotate-[1.6deg]" : "-rotate-[1.6deg]")
        }
      />
      <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-insigne-orange bg-insigne-bg shadow-[3px_3px_0_0_rgb(var(--c-sombra))]">
        <Marca className="h-4 text-insigne-orange" />
      </span>
    </div>
  );
}
